<template>
  <header
    class="app-header"
    :class="{ desktop: $isDesktop, 'header-opened': appMenuStore.menuVisible }"
    data-back-to-top
  >
    <nav :class="{ opened: appMenuStore.appMenuVisible }" class="nav-bar">
      <button
        data-test="menu-hamburger"
        class="hamburger"
        :aria-label="$t('Menu')"
        @click="appMenuStore.toggleAppMenu"
      >
        <span v-once class="hamburger-icon">
          <span class="hb1" />
          <span class="hb2" />
          <span class="hb3" />
          <span class="hb4" />
        </span>
      </button>
      <pu-homepage-link
        class="menu-btn"
        data-test="menu-homepage"
        exclude-type="homepageLink"
        :aria-label="$t('Home')"
        @click="$emit('home-btn-click')"
      >
        <img
          src="@/assets/images/pitchup-favicon.svg"
          alt=""
          width="36"
          height="32"
        />
      </pu-homepage-link>
      <div class="menu-spacer" />
      <pu-search-wizard-link
        class="menu-search"
        data-test="search-wizard-opener"
        :aria-label="$t('Search')"
      >
        <svg
          v-once
          xmlns="http://www.w3.org/2000/svg"
          fill-rule="evenodd"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="1.41"
          clip-rule="evenodd"
          viewBox="0 0 32 32"
        >
          <path
            id="search-icon"
            d="M19.47 21.84A11.75 11.75 0 018 23.31 11.79 11.79 0 01.92 10.23 11.69 11.69 0 0110.66.85 12.4 12.4 0 0112.29.7h.3a11.64 11.64 0 018.14 3.44 11.78 11.78 0 013.33 9.94 11.66 11.66 0 01-2.22 5.38l8.55 8.56c1.5 1.68.04 4.2-2.37 2.37l-8.55-8.55zM12.32 2.4a10 10 0 00-8.88 5.59 9.97 9.97 0 00-.06 8.83 10.13 10.13 0 009.06 5.7 10.05 10.05 0 00.13-20.12h-.26z"
          />
        </svg>
      </pu-search-wizard-link>

      <app-header-favourites />

      <button
        id="account"
        data-test="account-menu-icon"
        class="account-icon"
        :aria-label="$t('User account')"
        @click="appMenuStore.toggleAccountMenu"
      >
        <svg
          v-once
          id="account-icon"
          xmlns="http://www.w3.org/2000/svg"
          fill-rule="evenodd"
          stroke-linejoin="round"
          stroke-miterlimit="2"
          clip-rule="evenodd"
          viewBox="0 0 38 34"
        >
          <path
            fill="#0f972e"
            d="M16.2 18.7C11 18.8 5.5 20 1.9 23.2c-1 .9-1.9 2.1-1.9 3.5v5.9c.6 1.6 3 1.2 3.2 0v-6c0-.8.8-1.2 1.5-1.6C8 23 12 22 16 22h.3v.3-.3c4.1 0 8.4 1 11.7 3.1.7.4 1.4.9 1.4 1.6v5.8c.6 1.5 2.4 1.5 3.2 0v-5.9c0-2.1-2-3.7-3.6-4.6a25.5 25.5 0 00-12.8-3.3zm0-18.7c-3.6 0-7 2.7-7.7 6.3a8.2 8.2 0 004.7 9c4.4 1.8 10.2-1.2 11-6.1.6-4.5-3-9.1-7.8-9.2h-.2zm.1 3.2c3.2 0 5.8 3.8 4.2 7-1.3 2.5-5.3 3.3-7.5 1.2a5 5 0 01-.3-6.6c1-1 2.2-1.6 3.6-1.6v.4s-.1-.4 0-.4z"
          />
        </svg>

        <svg
          v-once
          id="back-icon"
          width="100%"
          height="100%"
          viewBox="0 0 26 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xml:space="preserve"
          :title="$t('Back')"
          style="
            fill-rule: evenodd;
            clip-rule: evenodd;
            stroke-linejoin: round;
            stroke-miterlimit: 1.41421;
          "
        >
          <path
            d="M12.679,3.045l-8.646,8.914l8.92,8.639c0.669,0.648 0.686,1.714 0.037,2.383c-0.648,0.668 -1.715,0.685 -2.385,0.037l-10.095,-9.777c-0.343,-0.333 -0.511,-0.776 -0.509,-1.219c-0.016,-0.443 0.139,-0.891 0.471,-1.234l9.785,-10.088c0.648,-0.668 1.716,-0.685 2.385,-0.038c0.668,0.648 0.685,1.715 0.037,2.383Z"
          />
          <path
            d="M24.677,2.858l-8.646,8.913l8.921,8.64c0.668,0.647 0.685,1.714 0.037,2.382c-0.648,0.668 -1.716,0.685 -2.385,0.037l-10.095,-9.777c-0.343,-0.333 -0.512,-0.776 -0.509,-1.219c-0.017,-0.442 0.138,-0.891 0.471,-1.234l9.784,-10.088c0.649,-0.668 1.716,-0.685 2.385,-0.037c0.669,0.648 0.686,1.715 0.037,2.383Z"
          />
        </svg>
      </button>
    </nav>
  </header>
</template>

<script setup lang="ts">
const { $isDesktop } = useNuxtApp()
const appMenuStore = useAppMenuStore(usePinia())
</script>

<style>
.noscroll .app-header {
  z-index: 0;
}
</style>
<style scoped>
header {
  display: block;
  width: 100vw;
  z-index: 10;
}

header.header-opened {
  z-index: 12;
  /* TODO: fix order in other place @Pete  */
}

.nav-bar {
  display: flex;
  height: 14vw;
  width: 100%;
}

.account-icon {
  border: none;
  background: none;
  box-shadow: none;
  border-radius: 0;
  transform: none;
}

.account-icon,
.nav-bar :deep(a) {
  position: relative;
  display: flex;
  flex: 0 0 20%;
  flex-direction: column;
  justify-content: space-around;
  color: white;
  align-items: center;
  text-decoration: none;
  padding: 0 1em;
  margin: 0.25em 0 0;
}

.nav-bar .menu-spacer {
  flex-grow: 3;
}

.nav-bar .favourites-link.router-link-active,
.nav-bar .menu-search.router-link-active,
.active-tab-search .nav-bar .menu-search {
  border-radius: 0.4em 0.4em 0 0;
  background: white;
  z-index: 1;
  position: relative;
}

.menu-search.router-link-active:after,
.active-tab-search .nav-bar .menu-search:after {
  background-color: var(--colour-orange);
  border-radius: 1em;
  bottom: 1vw;
  content: '';
  height: 3px;
  left: auto;
  margin: auto;
  position: absolute;
  width: 8vw;
}

.nav-bar :deep(svg) {
  height: 1.35em;
}

.nav-bar .menu-btn img {
  height: 2em;
}

.nav-bar .menu-btn {
  margin: -0.2em 0 0 0;
}

.nav-bar :deep(svg),
.nav-bar .menu-btn img {
  min-height: 1.25em;
  width: auto;
}

#search-icon {
  fill: var(--colour-light-green);
  stroke: var(--colour-light-green);
  stroke-width: 1.42;
}

#account-icon .notification {
  fill: var(--colour-red);
}

#account-icon {
  display: block;
}

#back-icon {
  display: none;
  fill: var(--colour-light-green);
  left: auto;
  position: absolute;
  right: 1.1em;
  top: 0.9em;
}

.account-open .account-icon::after,
.opened .hamburger::after {
  animation: fadein 0.5s;
  background-color: rgba(0, 0, 0, 0.6);
  bottom: 0;
  content: '';
  display: block;
  left: 0;
  min-height: calc(100vh - 14vw);
  min-width: 100vw;
  position: fixed;
  right: 0;
  top: 14vw;
  z-index: 9;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.active-tab-favourites:not(.account-open)
  .app-header
  .nav-bar:not(.opened):before,
.active-tab-search:not(.account-open) .app-header .nav-bar:not(.opened):before {
  background: rgba(67, 89, 125, 0.4);
  bottom: 0;
  content: '';
  display: block;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
}

.active-tab-favourites:not(.account-open) .account-icon,
.active-tab-favourites .hamburger,
.active-tab-search:not(.account-open) .account-icon,
.active-tab-search:not(.account-open) .hamburger,
.active-tab-search .nav-bar a:not(.menu-search),
.active-tab-favourites .nav-bar a:not(.router-link-active) {
  filter: contrast(0.5);
}

[data-menu-open='true']
  .active-tab-search:not(.account-open)
  .app-header
  .nav-bar:before {
  content: none;
}

[data-menu-open='true'] .active-tab-search:not(.account-open) .hamburger {
  filter: none;
}

.menu-search.router-link-exact-active,
.favourites-link.router-link-exact-active {
  pointer-events: none;
}

.hamburger,
.hamburger:active {
  height: 3.1em;
  width: 2.65em;
  align-items: center;
  background: none;
  border-radius: 0;
  border: none;
  box-shadow: none;
  display: flex;
  justify-content: center;
  padding: 0 0 0 4%;
  transform: none;
}

.hamburger-icon {
  cursor: pointer;
  display: block;
  height: 1.3em;
  position: relative;
  width: 100%;
  margin: auto;
}

.hamburger-icon span {
  background: var(--colour-light-green);
  border-radius: 0.5em;
  display: block;
  height: 0.2em;
  left: 0;
  min-height: 3px;
  opacity: 1;
  position: absolute;
  transform: rotate(0deg);
  transition: 0.25s ease-in;
  width: 100%;
}

.hb1 {
  top: 0;
}

.hb2,
.hb3 {
  /* top: 2.5vw; */
  top: 0.555em;
}

.hb4 {
  /* top: 5vw; */
  top: 1.1em;
}

.hb1,
.hb4 {
  transition: opacity;
  opacity: 1;
}

.opened .hamburger-icon span {
  transition: 0.25s ease-out 0.25s;
}

.opened .hb1,
.opened .hb4 {
  /* top: 2.5vw; */
  top: 0.555em;
  width: 0;
  left: 50%;
  transition: opacity;
  opacity: 0;
}

.opened .hb2 {
  transform: rotate(45deg);
}

.opened .hb3 {
  transform: rotate(-45deg);
}

/* mobile landscape */
@media screen and (min-width: 320px) and (max-width: 998px) and (orientation: landscape) {
  .nav-bar {
    height: 3.5em;
  }

  .hamburger,
  .hamburger:active {
    width: 4em;
    padding-left: 1.4em;
    height: 4.5em;
  }

  .hamburger-icon {
    height: 2em;
  }

  .nav-bar :deep(svg),
  .nav-bar .menu-btn img {
    min-height: 2em;
  }
}
</style>
